import { render, staticRenderFns } from "./DataCounter.vue?vue&type=template&id=2a75fa8b&scoped=true"
import script from "./DataCounter.vue?vue&type=script&lang=js"
export * from "./DataCounter.vue?vue&type=script&lang=js"
import style0 from "./DataCounter.vue?vue&type=style&index=0&id=2a75fa8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a75fa8b",
  null
  
)

export default component.exports